import { STEP_PARTS, stepValid } from '@/config/membershipTierWizardSteps'

const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null)

const unchanged = (part, payload, baseline) => part.keys.every(key => same(payload[key], baseline[key]))

export const editStepValid = (key, data, payload, baseline) => {
  const parts = STEP_PARTS[key]
  if (!parts || !baseline) return stepValid(key, data)
  return parts.every(part => part.valid(data) || unchanged(part, payload, baseline))
}
